export const getFontSizeNumber = (fontSize: string) => parseInt(fontSize.replace('px', ''), 10);

export const isNumber = (value: unknown): value is number => typeof value === 'number';

export const calculatePercentageChange = (prevValue: number, newValue: number) => {
  if (prevValue === 0) {
    return 0;
  }

  const change = newValue - prevValue;
  const percentageChange = (change / prevValue) * 100;

  return percentageChange;
};

export const addPercentage = (value: number, percentage: number) =>
  value + (value * percentage) / 100;

export const minusPercentage = (value: number, percentage: number) =>
  value - (value * percentage) / 100;
